import { useDrawer } from '../../../hooks';
import { DrawerProvider } from '../../../contexts/drawer';

const Drawer = ({ children, ...props }) => {
  const {
    isOpen,
    setIsOpen,
    closeDrawer,
    exitProps,
    linkProps,
    listProps,
    triggerProps,
  } = useDrawer(props);

  return (
    <DrawerProvider
      value={{
        isOpen,
        setIsOpen,
        closeDrawer,
        exitProps,
        linkProps,
        listProps,
        triggerProps,
      }}
    >
      {children}
    </DrawerProvider>
  );
};

export default Drawer;
